import script from "./NationalFinalists.vue?vue&type=script&setup=true&lang=js"
export * from "./NationalFinalists.vue?vue&type=script&setup=true&lang=js"

import "./NationalFinalists.vue?vue&type=style&index=0&id=a685e9ca&lang=scss&scoped=true"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\100\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a685e9ca"]])

export default __exports__